<template>
    <div v-if="modalAlert" class="toggle-alert">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div class="">
                    <div id="alert-modal" class="card bg-orange-gradLight">
                        <button class="btn-close" @click="modalAlertHandler">
                            <img :src="close" alt="close">
                        </button>
                        <div class="card-body">
                            <div class="mensages-container">
                                <img :src="warning" alt="warning" class="message-img">
                                <h1>Sessão expirada</h1>
                                <p>Faz login novamente.</p>

                                <div class="modal-bottom double">
                                    <div class="text-center">
                                        <button class="btn-bg" @click="modalAlertHandler">Fechar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'
import icWarning from '../../svg/ic_warning.svg'

export default {
    data() {
        return {
            close: icClose,
            warning: icWarning,
            modalAlert: false
        }
    },
    methods: {
        modalAlertHandler() {
            this.modalAlert = !this.modalAlert;

            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
    },
    mounted() {
        this.modalAlertHandler();
    },
}
</script>

<style>

</style>
